import { ChatProviderType } from './ChatProviderType';

// TODO: confirm if any of the assistants specific stuff is needed then cleanup
// ==========================================================
// Assistant-session support types (temporary: keep here until
// we confirm ownership and usage)
// ==========================================================

export interface ThreadRunConfig {
    temperature?: number;
    maxPromptTokens?: number;
    maxCompletionTokens?: number;
}

// We need to confirm whether `assistantId` and `purpose` are actually required
// at the domain level, or if this can eventually be normalized into a more
// general document/file model.
export interface ChatSessionAttachedFiles {
    id: string;
    assistantId: string;
    threadId: string;
    createdAt: string;
    purpose: string;
    fileName: string;
    fileId: string;
    bytes: number;
}

// File interface previously used by Assistants
// mimics the IFile interface in the legacy ChatSession Model used by Assitants thread
// retained in case its needed.
export interface AssistantFile {
    id: string;
    ThreadId: string;
    createdAt: string;
    purpose?: string;
    fileName: string;
    bytes: number;
}

export enum AssistantType {
    Standard = 'standard',
    Engagement = 'engagement',
}

// ==========================================================
// Engagement / EA types (temporary: likely move later)
// ==========================================================

export interface TeamMembers {
    businessUnit: string;
    businessUnitId: string;
    department: string;
    departmentId: string;
    employeeId: string;
    jobFunction: string;
    lineOfBusiness: string;
    loginName: string;
    operationUnit: string;
    createdDate: Date;
    id: string;
    isDeleted: boolean;
    modifiedDate: Date;
    name: string;
}

export enum AcceleratorType {
    checklist,
    onboarding,
    kickoffdeck,
}

export interface EngagementAccelerator {
    acceleratorType: AcceleratorType;
    name: string;
    description: string;
    iTracProjectCode: string;
    clientName: string;
    industry: string;
    solution: string;
    solutionSegment: string;
    serviceOfferings: string;
    thirdPartyTools: string;
    departmentInScope: string;
    contractorInformation: string;
    backgroundCheck: string;
    country: string;
    region: string;
    deliveryCenter: string;
    ecosystemPartner: string;
    clientDataRequirements: string;
    pursuitTeams: TeamMembers[];
    teamsSite: string;
    teamUrl: string;
    fileFormat: string;
    powerPointFormat: string;
    riskAssessmentId?: string;
    engagementId?: string;
}

export enum FileType {
    SOW = 0,
    MSA,
    Proposal,
}

export interface EngagementDocument {
    containerId: string;
    fileName: string;
    fileType: FileType | null;
    fileId: string;

    // Temporary compatibility fields. If provider mappers can normalize casing,
    // these should eventually be removed from the domain model.
    ContainerId?: string;
    FileName?: string;
    FileType?: FileType | null;
    FileId?: string;
}

export interface EngagementFiles {
    engagementId: string;
    files: EngagementDocument[];
}

// ==========================================================
// Assistant blob/document types (temporary: likely move later)
// ==========================================================

// This needs to be renamed later because it means something different from the
// other chat/document concepts in the app.
export enum CategoryType {
    MSA = 1,
    SOW,
    Proposal,
    Other,
}

export interface ChatSessionDocument {
    id: string;
    fileName: string;
    categoryType: CategoryType;
    blobUrl: string;
}

// ==========================================================
// Core chat session models
// ==========================================================

export interface BaseChatSession {
    id: string;
    userId: string;
    title: string;
    providerType: ChatProviderType;
    createdDate: number;
    modifiedDate?: number;
    isTitleGenerated?: boolean; // check whether this is needed
}

export interface ProGPTChatSession extends BaseChatSession {
    providerType: ChatProviderType.ProGPT;
    agentId: string; // normalized to keep things simple. progpt agent id at the chat session and agent level will always be 'progpt-default'
    persona: string;
}


export interface AssistantsChatSession extends BaseChatSession {
    providerType: ChatProviderType.Assistants;
    agentId: string;
    assistantType?: AssistantType;
    threadRunConfig?: ThreadRunConfig;
    // promptEnhancerPersona?: string;
    attachedFiles?: ChatSessionAttachedFiles[];
    ThreadFiles?: AssistantFile[];
    blobFiles?: ChatSessionDocument[];
    shellId?: string;
    parentChatSessionId?: string;
    engagementAccelerator?: EngagementAccelerator[];
    engagementFiles?: EngagementDocument[];
    processedEngagementFiles?: string[];
}

export interface NexusChatSession extends BaseChatSession {
    providerType: ChatProviderType.Nexus;
    agentId: string;
    files?: string[]; // list of file names
    isCodeInterpreterEnabled?: boolean;
    isFileSearchEnabled?: boolean;
    metadata?: Record<string, unknown>;
}

export type ChatSession =
    | ProGPTChatSession
    | AssistantsChatSession
    | NexusChatSession;


